<template>
  <main>
    <!-- sticky top nav -->
    <nav id="navi" class="container-fluid sticky-top bg-white pt-1 pt-md-2 mb-1 shadow-sm">
      <div v-if="menuOpen" class="container">
        <div v-if="alert" class="alert alert-warning" role="alert">
          CH-R -mallin kohdalla varusteselaimessa on toimintahäiriö. Ongelmaa selvitetään.
          <button @click="alert = null" type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="row">
          <div class="col-12 col-md mb-1 mb-md-0">
            <label for="automalli">Automalli</label>
            <select name="automalli" id="automalli" v-model="input.automalli">
              <option value="all">Kaikki automallit</option>
              <option :value="model.model_key" v-for="model in models" :key="model.model_key">
                {{model.name}}
              </option>
            </select>
          </div>
          <div class="col-12 col-md mb-1 mb-md-0">
            <label for="tuoteryhma">Tuoteryhmä</label>
            <select name="tuoteryhma" id="tuoteryhma" v-model="input.tuoteryhma">
              <option value="all">Kaikki tuoteryhmät</option>
              <option :value="group" v-for="group in groups" :key="group.key">
                {{group}}
              </option>
            </select>
          </div>
          <div class="col-12 col-md">
            <div class="form-group position-relative">
              <label for="suodatus">Suodata tuloksia</label>
              <input type="text" class="form-control" id="suodatus" v-model="input.suodatus">
              <div @click="input.suodatus = null" class="position-absolute cursor--pointer" style="top: 2.3em; right: .7em;"><i class="fa fa-times-circle text-grey-paragraph"></i></div>
            </div>
          </div>
        </div>

        <div class="row mt-1 pb-2">
          <div class="col-12 col-md-6 mb-1 mb-md-0 d-flex mr-auto">
            <span v-if="accessories"><strong>{{itemCount}}</strong> varustetta</span>
          </div>
          <div class="col-12 col-md-4 mb-1 mb-md-0">
            <select name="sortAccessories" id="sortAccessories" v-model="sortMode" @change="sortAccessories(sortMode)">
              <option value="group">Tuoteryhmittäin</option>
              <option value="name">Aakkosjärjestyksessä</option>
              <option value="priceAsc">Hinnan mukaan, nouseva</option>
              <option value="priceDesc">Hinnan mukaan, laskeva</option>
              <option value="popularity">Suosion mukaan</option>
            </select>
          </div>

          <div class="col-12 col-md-2 btn-group btn-group-sm" role="group" aria-label="Toggle view mode">
            <button type="button" class="c-btn btn" v-on:click="viewMode = 'grid'" :class="{ 'c-btn--active': (viewMode === 'grid') }"><i class="fa fa-th"></i></button>
            <button type="button" class="c-btn btn border-left mt-0" v-on:click="viewMode = 'list'" :class="{ 'c-btn--active': (viewMode === 'list') }"><i class="fa fa-list"></i></button>
          </div>
        </div>
      </div>
      <div class="container text-center">
        <!-- Show Bootstrap spinner until data is fetched -->
        <div v-if="!models || !groups || !accessories">
          <div class="spinner-border text-red mb-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <button v-else @click="menuOpen = !menuOpen" type="button" class="btn-sm mb-1" style="background: #f0f0f0; border: none; outline: none; border-radius: 50%;"><i class="fa text-red" :class="menuOpen ? 'fa-chevron-up' : 'fa-bars'"></i></button>
      </div>
    </nav>

    <div class="container text-left">
      <section v-if="viewMode === 'list' && accessories" id="listview">
        <article v-for="acc in accessories" :key="acc.uid" v-show="filterAccessories(acc)" class="c-count" :class="{ 'c-accessory--open': (openItem === acc.uid) }">

<!--
          <div class="row pb-1">
            <div class="col">
              <h3>{{test(acc.group)}}</h3>
            </div>
          </div>
-->
           <div v-if="openItem === acc.uid" class="bg-grey-light ">
            <div class="text-align--right">
              <div class="cursor--pointer py-1 pr-2" @click="closeAccessory(acc.uid)"><i class="fa fa-times-circle text-grey-paragraph"></i> Sulje</div>
            </div>
            <OpenAccessory :acc="acc" :model="input.automalli"></OpenAccessory>
          </div>

          <div v-else class="p-1 border-top">
            <div class="row d-flex justify-content-between">
              <div class="col">
                <input type="radio" class="c-form-check-input form-check-input" name="open" :id="'open-' + acc.uid" :value="acc.uid" v-model="openItem">
                <label class="c-form-check-label form-check-label cursor--pointer" :for="'open-' + acc.uid">{{acc.name}}</label>
              </div>
              <div class="col-3 text-right">
                {{dealerPrice(acc.price, acc.dealer_prices)}}
              </div>
            </div>
            <div class="row">
              <div class="col support-text text-muted">
                {{acc.category}}, tuotekoodi: {{acc.manufacturer_code}}<span v-if="acc.package_code">, pakettikoodi: {{acc.package_code}}</span>
              </div>
              <div class="col-2">
                <div class="form-group float-right position-relative" style="right: -15px; margin-bottom: 0;">
                  <input :id="'selected-' + acc.uid" :value="acc" v-model="selected" type="checkbox" class="form-check-input">
                  <label :for="'selected-' + acc.uid" class="form-check-label cursor--pointer">Valitse</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-1">
                <div v-if="input.automalli === 'all'">
                  <span v-for="(item, index) in acc.cars" :key="index" class="badge bg-grey-light text-grey-paragraph border c-mr-half">{{index}}</span>
                </div>
              </div>
              <div v-if="acc.installed_by !== 'DEALER' || acc.group === 'varustepaketti'" class="col-12 support-text"><i class="fa fa-info-circle text-red"></i>&nbsp; Saatavilla vain uuden auton tilauksen yhteydessä</div>
            </div>
          </div>

        </article>
      </section>

      <section v-if="viewMode === 'grid' && accessories" id="gridview" class="row d-flex">
        <!--
        <article v-for="acc in accessories" :key="acc.uid" v-show="filterAccessories(acc.name + '' + acc.manufacturer_code + '' + acc.package_code + '' + acc.keywords + '' + acc.category)" class="c-count col-12 col-sm-6 col-md-4 mb-3" :class="{ 'c-accessory--open': (openItem === acc.uid) }">
        -->
        <article v-for="acc in accessories" :key="acc.uid" v-show="filterAccessories(acc)" class="c-count col-12 col-sm-6 col-md-4 mb-3" :class="{ 'c-accessory--open': (openItem === acc.uid) }">

          <div v-if="openItem === acc.uid" class="bg-grey-light border-0">
            <div class="text-align--right">
              <div class="cursor--pointer py-1 pr-2" @click="closeAccessory(acc.uid)"><i class="fa fa-times-circle text-grey-paragraph"></i> Sulje</div>
            </div>
            <OpenAccessory :acc="acc" :model="input.automalli"></OpenAccessory>
          </div>

          <div v-else class="card rounded-0 border-0">
            <div class="c-card-img">
              <div class="c-card-img-container">
                <img v-if="acc.image_uri" :src="acc.image_uri" :alt="acc.manufacturer_code" class="card-img-top border rounded-0">
                <img v-else src="../assets/placeholder.png" class="card-img-top border rounded-0">
              </div>

              <div class="form-group form-check-inline position-absolute" style="top: 10px; right: -5px; padding-right: 0; padding-left: 6px; background-color: rgba(255,255,255,.8); border-radius: .25rem;">
                <input :id="'selected-' + acc.uid" :value="acc" v-model="selected" type="checkbox" class="form-check-input">
                <label :for="'selected-' + acc.uid" class="form-check-label cursor--pointer">Valitse</label>
              </div>
            </div>
            <div class="card-body pt-1">
              <div class="mb-1">
                <input type="radio" class="c-form-check-input form-check-input" name="open" :id="'open-' + acc.uid" :value="acc.uid" v-model="openItem" @click="updatePopularCount(acc)">
                <label class="c-form-check-label form-check-label cursor--pointer" :for="'open-' + acc.uid">{{acc.name}}</label>
              </div>
              <p>
                {{dealerPrice(acc.price, acc.dealer_prices)}}
              </p>

              <div class="support-text text-muted mb-1">
                <!-- <mark >Suosioindeksi: {{acc.popularity}}</mark><br> -->
                {{acc.category}}<br>
                Tuotekoodi: {{acc.manufacturer_code}}<br>
                <span v-if="acc.package_code">Pakettikoodi: {{acc.package_code}}</span>
              </div>
              <div v-if="input.automalli === 'all'">
                <span v-for="(item, index) in acc.cars" :key="index" class="badge bg-grey-light text-grey-paragraph border c-mr-half">{{index}}</span>
              </div>
              <div v-if="acc.installed_by !== 'DEALER' || acc.group === 'varustepaketti'" class="mt-1 text-red support-text">Saatavilla vain uuden auton tilauksen yhteydessä</div>
            </div>
          </div>

        </article>
      </section>

      <div class="fixed-bottom text-left py-1" style="padding-left: 18px;">
        <i @click="scrollToTop()" class="fa fa-2x fa-arrow-circle-up cursor--pointer" style="color: #f0f0f0;"></i>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
import smoothscroll from 'smoothscroll-polyfill'
import OpenAccessory from '../components/OpenAccessory'

// kick off the polyfill for IE/Edge: http://iamdustan.com/smoothscroll/
smoothscroll.polyfill()

let groupTitle = ''

export default {
  name: 'haku',

  components: {
    OpenAccessory
  },

  data () {
    return {
      input: {
        automalli: 'all',
        tuoteryhma: 'all',
        suodatus: null
      },
      selected: [],
      itemCount: 0,
      viewMode: 'grid',
      sortMode: 'group',
      openItem: null,
      menuOpen: true,
      alert: false
    }
  },

  computed: {
    ...mapGetters({
      models: 'getModels',
      groups: 'getGroups',
      accessories: 'getAccessories',
      initialSearch: 'getInitialSearch',
      dealer: 'getDealer',
      storeSelected: 'getSelected'
    })
  },

  mounted () {
    this.$store.dispatch('fetchPopularity')

    // set defaults if search is passed from another view
    if (this.initialSearch[0] === 'm') { // model
      this.input.automalli = this.initialSearch[1]
    } else if (this.initialSearch[0] === 'g') { // group
      this.input.tuoteryhma = this.initialSearch[1]
    } else if (this.initialSearch[0] === 's') { // filter
      this.input.suodatus = this.initialSearch[1]
    } else {
      // fetch data on init if no passed values
      this.$store.dispatch('fetchModels')
      this.$store.dispatch('fetchGroups')
      this.$store.dispatch('fetchAllAccessories')
    }
  },

  updated () {
    this.updateCount()
  },

  watch: {
    'input.automalli' () {
      this.fetchAccessories()
    },

    'input.tuoteryhma' () {
      this.fetchAccessories()
    },

    'input.suodatus' () {
      if (!this.accessories) {
        this.fetchAccessories()
      }
      this.updateCount()
    },

    selected () {
      if (this.selected.length >= 0) {
        this.$store.dispatch('updateSelected', this.selected)
      }
    },

    storeSelected () {
      if (this.storeSelected === null && this.selected.length > 0) {
        this.selected = []
      } else {
        this.$nextTick(() => {
          this.selected = this.storeSelected
        })
      }
    },

    openItem () {
      if (this.openItem) {
        this.$nextTick(() => {
          const openElement = document.getElementsByClassName('c-accessory--open')[0]
          const naviHeight = document.getElementById('navi').clientHeight

          window.scrollTo({
            top: openElement.offsetTop - naviHeight - 30,
            left: 0,
            behavior: 'smooth'
          })
        })
      }
    }
  },

  methods: {
    fetchAccessories: function () {
      let m = this.input.automalli
      let g = encodeURIComponent(this.input.tuoteryhma)

      if (this.input.automalli === 'all') {
        m = false
      }

      if (this.input.tuoteryhma === 'all') {
        g = false
      }

      if (m && g && g !== 'Varustepaketti') {
        console.log('get by both: ' + m + ' & ' + g)
        const p = [m, g]
        this.$store.dispatch('fetchAccessoriesbyModelAndGroup', p)
        this.scrollToTop()
      } else if (m && g === 'Varustepaketti') {
        console.log('get packs my model: ' + m)
        this.$store.dispatch('fetchPacksbyModel', m)
        this.scrollToTop()
      } else if (!m && g === 'Varustepaketti') {
        console.log('get by packs')
        this.$store.dispatch('fetchPacks', g)
        this.scrollToTop()
      } else if (!m && !g) {
        console.log('get all')
        this.$store.dispatch('fetchAllAccessories')
        this.scrollToTop()
      } else if (m) {
        console.log('get by model: ' + m)
        this.$store.dispatch('fetchAccessoriesbyModel', m)
        this.scrollToTop()
      } else if (g) {
        console.log('get by group: ' + g)
        this.$store.dispatch('fetchAccessoriesbyGroup', g)
        this.scrollToTop()
      }
      /*
      if (m && g ) {
        console.log('get by both')
        let p = [m, g]
        this.$store.dispatch('fetchAccessoriesbyModelAndGroup', p)
        this.scrollToTop()
      } else if (!m && !g) {
        console.log('get all')
        this.$store.dispatch('fetchAllAccessories')
        this.scrollToTop()
      } else if (m) {
        console.log('get by model: ' + g)
        this.$store.dispatch('fetchAccessoriesbyModel', m)
        this.scrollToTop()
      } else if (g === 'Varustepaketti') {
        console.log('get by packs')
        this.$store.dispatch('fetchPacks', g)
        this.scrollToTop()
      } else if (g) {
        console.log('get by group: ' + g)
        this.$store.dispatch('fetchAccessoriesbyGroup', g)
        this.scrollToTop()
      }
      */
    },

    filterAccessories: function (obj) {
      if (this.input.suodatus) {
        // accepts now the whole item object
        const targetString = JSON.stringify(obj).toUpperCase()
        const inputArray = this.input.suodatus.toUpperCase().split(' ')
        const out = []

        _.forEach(inputArray, function (x) {
          if (_.includes(targetString, x)) {
            out.push(true)
          } else {
            out.push(false)
          }
        })

        const u = _.uniq(out)
        if (u.length === 1 && u[0] === true) {
          return true
        }
      } else {
        return true
      }
    },

    countVisible: function () {
      const items = document.getElementsByClassName('c-count')
      const itemsArray = [].slice.call(items)
      const displayShow = itemsArray.filter(function (el) {
        return getComputedStyle(el).display !== 'none'
      })
      this.itemCount = displayShow.length
    },

    updateCount: function () {
      if (this.accessories && !this.input.suodatus) {
        this.itemCount = this.accessories.length
      } else {
        this.countVisible()
      }
    },

    sortAccessories: function (mode) {
      this.$store.dispatch('updateSortMode', mode)
    },

    closeAccessory: function (uid) {
      // deselect radio input
      this.openItem = null
      this.$nextTick(() => {
        document.getElementById('open-' + uid).checked = false
      })
    },

    getOffsetTop: function (elem) {
      let distance = 0
      // Loop up the DOM
      if (elem.offsetParent) {
        do {
          distance += elem.offsetTop
          elem = elem.offsetParent
        } while (elem)
      }
      // Return our distance
      return distance < 0 ? 0 : distance
    },

    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    updatePopularCount: function (a) {
      const p = [a.uid, a.name].join(';')
      axios
        .post(process.env.VUE_APP_DEMO_PHP_BACKEND + '/popular.php', p)
        .then(response => { console.log(response) })
        .catch(error => { console.log(error) })
    },

    dealerPrice: function (p, dp) {
      if (this.dealer !== 'none') {
        if (dp[this.dealer]) {
          return parseInt(dp[this.dealer], 10) + ' €'
        } else {
          return p + ' €'
        }
      } else {
        return p + ' €'
      }
    },

    test: function (g) {
      const o = groupTitle

      if (o !== g) {
        groupTitle = g
        return g
      }
    }
  }
}
</script>

<style>
/* custom styles for responsive fixed aspect-ratio accessory images */
.c-card-img {
  position: relative;
  width: 100%;
}

.c-card-img:after {
  content: "";
  display: block;
  padding-bottom: 100%; /* aspect-ratio 1:1 */
}

.c-card-img-container {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  text-align: center;
}

.card-img-top {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}

.c-mr-half {
  margin-right: .5em;
}

.c-accessory--open {
  flex: 100%;
  max-width: 100%;
 }

.c-btn {
  min-width: 50px;
  height: 46px !important;
}

.c-btn .fa {
  margin-left: 0;
  padding-right: 0;
}

.c-btn:hover, .c-btn:focus, .c-btn:active, .c-btn--active {
  background: #595d60;
  color: #fff;
  outline: none;
}

[id^=open-] {
  border: 1px solid red !important;
}

input[type=radio].c-form-check-input + label:before {
  content: "";
}

.c-form-check-label {
  display: inline;
  margin-left: -20px;
  /* font: 16px/25.6px NotoSans-Regular; */
  font: 16px/24px 'ToyotaType-Semibold', Arial, Helvetica, sans-serif;
  color: #282830;
  white-space: normal
}

.c-form-check-label:hover {
  color: #ff0022;
}

.c-checkbox-input--hidden {
  visibility: hidden;
}
</style>
